// All mock data for Jesse J. Adams Property Master Portfolio
// Replace this with backend data when full-stack integration begins.

export const SITE = {
  name: "Jesse J. Adams",
  role: "Los Angeles Based IATSE Local 44 Property Master",
  tagline: "Creative instincts, historical research, archive-level detail, and budget-minded department leadership for film and television.",
  shortIntro:
    "Los Angeles-based Property Master with 15+ years across studio comedies, streaming features, television, action, period work, and specialty fabrication. Career path: prop PA / researcher → Assistant Property Master → Property Master.",
  email: "info@propmeister.art",
  phone: "(818) 239-9849",
  imdb: "https://www.imdb.com/name/nm2417385/",
  basedIn: "Los Angeles, CA",
  travel: "Available worldwide \u2014 past credits include LA, Atlanta, New York, New Orleans, and Chicago.",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "The Prop Department", to: "/services" },
  { label: "Trailer + Kit", to: "/trailer-kit" },
  { label: "Resume", to: "/resume" },
  { label: "Portfolio", to: "/portfolio" },
  { label: "Contact", to: "/contact" },
];

export const IMAGES = {
  hero: "/images/hero.jpg",
  heroMobile: "/images/hero-mobile.jpg",
  filmSet2: "https://images.unsplash.com/photo-1612544409025-e1f6a56c1152?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxmaWxtJTIwc2V0JTIwcHJvZHVjdGlvbnxlbnwwfHx8YmxhY2t8MTc3Nzc2MDI5N3ww&ixlib=rb-4.1.0&q=85",
  workshop1: "https://images.unsplash.com/photo-1727413433599-496949ef8196?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHw0fHx3b3Jrc2hvcCUyMGZhYnJpY2F0aW9ufGVufDB8fHx8MTc3Nzc2MDI5N3ww&ixlib=rb-4.1.0&q=85",
  workshop2: "https://images.unsplash.com/photo-1764114440403-4dd539cb582a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHx3b3Jrc2hvcCUyMGZhYnJpY2F0aW9ufGVufDB8fHx8MTc3Nzc2MDI5N3ww&ixlib=rb-4.1.0&q=85",
  typewriter1: "/images/steamboat-willie.jpg",
  typewriter2: "/images/disney-alice.jpg",
  props1: "https://images.pexels.com/photos/29696177/pexels-photo-29696177.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  props2: "https://images.unsplash.com/photo-1705996520688-2818d17a86b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxmaWxtJTIwcHJvcHN8ZW58MHx8fHwxNzc3NzYwMzAyfDA&ixlib=rb-4.1.0&q=85",
  props3: "https://images.unsplash.com/photo-1503156829262-c0d473ac10e8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHw0fHxmaWxtJTIwcHJvcHN8ZW58MHx8fHwxNzc3NzYwMzAyfDA&ixlib=rb-4.1.0&q=85",
  hands1: "https://images.unsplash.com/photo-1771573391500-64cc1cbb3e7b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxjcmFmdHNtYW4lMjBoYW5kc3xlbnwwfHx8fDE3Nzc3NjAzMDJ8MA&ixlib=rb-4.1.0&q=85",
  hands2: "https://images.unsplash.com/photo-1761537478067-67d8cd030561?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxjcmFmdHNtYW4lMjBoYW5kc3xlbnwwfHx8fDE3Nzc3NjAzMDJ8MA&ixlib=rb-4.1.0&q=85",
  tools1: "https://images.unsplash.com/photo-1590880795696-20c7dfadacde?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHx3b3Jrc2hvcCUyMHRvb2xzfGVufDB8fHx8MTc3Nzc2MDMwOHww&ixlib=rb-4.1.0&q=85",
  tools2: "https://images.unsplash.com/photo-1522832712787-3fbd36c9fe2d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHx3b3Jrc2hvcCUyMHRvb2xzfGVufDB8fHx8MTc3Nzc2MDMwOHww&ixlib=rb-4.1.0&q=85",
  tools3: "https://images.unsplash.com/photo-1505582866941-6788e0205dd2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHx3b3Jrc2hvcCUyMHRvb2xzfGVufDB8fHx8MTc3Nzc2MDMwOHww&ixlib=rb-4.1.0&q=85",
  trailer: "https://images.unsplash.com/photo-1616432043562-3671ea2e5242?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxzZW1pJTIwdHJhaWxlcnxlbnwwfHx8fDE3Nzc3NjAzNzF8MA&ixlib=rb-4.1.0&q=85",
  portrait: "/images/portrait.jpg",
  shelves1: "https://images.unsplash.com/photo-1552836514-bbf70221e437?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHx3b3Jrc2hvcCUyMHNoZWx2ZXN8ZW58MHx8fHwxNzc3NzYwMzY0fDA&ixlib=rb-4.1.0&q=85",
  shelves2: "https://images.unsplash.com/photo-1769173129390-a57de2512782?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHx3b3Jrc2hvcCUyMHNoZWx2ZXN8ZW58MHx8fHwxNzc3NzYwMzY0fDA&ixlib=rb-4.1.0&q=85",
  bts: "https://images.unsplash.com/photo-1681137063068-081072cf04b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHxmaWxtJTIwc2V0JTIwY3Jld3xlbnwwfHx8fDE3Nzc3NjAzNzJ8MA&ixlib=rb-4.1.0&q=85",
  toolWall: "https://images.unsplash.com/photo-1549636367-13c144c47063?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHx3b3Jrc2hvcCUyMHNoZWx2ZXN8ZW58MHx8fHwxNzc3NzYwMzY0fDA&ixlib=rb-4.1.0&q=85",
};

export const PORTFOLIO_PROJECTS = [
  {
    slug: "all-the-way",
    title: "All the Way",
    subtitle: "Recreating LBJ & The Civil Rights Act of 1964",
    director: "Jay Roach",
    studio: "HBO",
    year: "2016",
    role: "Assistant Property Master",
    poster: "/images/all-the-way.jpg",
    hero: "https://images.squarespace-cdn.com/content/v1/65431750d7376610b5f5026e/6d00ca3d-f014-4b4f-8a5b-a593a1b2092f/Screenshot+2026-02-24+at+9.04.19%E2%80%AFPM.png",
    images: [
      "https://images.squarespace-cdn.com/content/v1/65431750d7376610b5f5026e/6d00ca3d-f014-4b4f-8a5b-a593a1b2092f/Screenshot+2026-02-24+at+9.04.19%E2%80%AFPM.png",
      "https://images.squarespace-cdn.com/content/v1/65431750d7376610b5f5026e/df9a10b4-d49a-4d1c-ab65-902aa6fe7471/Screenshot+2026-02-24+at+9.03.38%E2%80%AFPM.png",
      "https://images.squarespace-cdn.com/content/v1/65431750d7376610b5f5026e/7f10f7d8-2d12-4c5a-8ad7-67941fbf910a/Screenshot+2026-02-24+at+9.03.47%E2%80%AFPM.png",
    ],
    body: [
      "On All the Way, we weren't just telling a story — we were recreating a real, high-stakes moment in American history: Lyndon B. Johnson pushing the Civil Rights Act of 1964 through. So the props couldn't be \"period-ish.\" They had to be dead-on.",
      "The film is based on Robert Schenkkan's Tony Award–winning play, which was developed through the Oregon Shakespeare Festival before it went to Broadway. That theatre DNA was baked into the whole process — rehearsals were run like a live stage production, with the cast working scenes the way you would in theatre, not like a typical film where everything gets built in pieces.",
      "I'd worked with Jay Roach before on Dinner for Schmucks, so I already knew how detail-oriented he is. With a director like Jay, you don't get to hand-wave anything — and on a project like this, you shouldn't. We worked extremely hard to make the props as historically accurate and faithfully recreated as possible.",
      "And because Bryan Cranston had already lived inside LBJ on stage — and won the Tony for it — it raised the bar even higher. I worked closely alongside him to help build a world that felt completely real to inhabit, not just accurate to look at. When an actor is doing that level of work, the details matter in a different way — the right weight in the hand, the right shape, the right era-specific function — because it all feeds the performance.",
      "I collaborated directly with the archivists at the LBJ Library and spent weeks buried in research to match the real items as closely as possible. We replicated LBJ's personal pieces — his watch and glasses — down to the correct size and model. I also helped recreate hero props that were central to the story: the Dictaphone he used in the White House, an exact replica of the bill itself, and the fountain pen used to sign it.",
      "The goal was always the same: respect the history, support the performance, and make the world feel so authentic that the audience never questions a single thing they're seeing.",
    ],
  },
  {
    slug: "agent-carter",
    title: "Marvel's Agent Carter",
    subtitle: "Building the SSR paperwork system + 1940s sci-fi",
    director: "Various",
    studio: "Marvel / ABC",
    year: "2015",
    role: "Property Production Assistant",
    poster: "/images/agent-carter.jpg",
    hero: "https://images.squarespace-cdn.com/content/v1/65431750d7376610b5f5026e/7cd14630-404f-43f4-be94-12f195bb4fda/Screenshot+2026-02-24+at+9.05.09%E2%80%AFPM.png",
    images: [
      "https://images.squarespace-cdn.com/content/v1/65431750d7376610b5f5026e/7cd14630-404f-43f4-be94-12f195bb4fda/Screenshot+2026-02-24+at+9.05.09%E2%80%AFPM.png",
      "https://images.squarespace-cdn.com/content/v1/65431750d7376610b5f5026e/a5c25fc7-a91a-4761-8c13-a49ce5d92059/Screenshot+2026-02-24+at+9.04.43%E2%80%AFPM.png",
      "https://images.squarespace-cdn.com/content/v1/65431750d7376610b5f5026e/bece5baa-b6c2-4eab-a62c-9e86f6003c22/Screenshot+2026-02-24+at+9.04.54%E2%80%AFPM.png",
      "https://images.squarespace-cdn.com/content/v1/65431750d7376610b5f5026e/b721008d-69d6-43f5-8757-2cc077a9ed41/Screenshot+2026-02-24+at+9.05.17%E2%80%AFPM.png",
      "https://images.squarespace-cdn.com/content/v1/65431750d7376610b5f5026e/c62089dd-d70e-4164-8db0-89e89e3517b6/Screenshot+2026-02-24+at+9.05.25%E2%80%AFPM.png",
    ],
    body: [
      "On Season 1 of Marvel's Agent Carter, I helped build the show's 1940s world while keeping everything visually consistent with the Marvel Cinematic Universe. The work lived at the intersection of strict period authenticity and \"vintage\" sci-fi — futuristic concepts that still had to look like they were engineered with WWII-era materials and sensibilities, without breaking the visual language Marvel had already established on screen.",
      "My primary responsibility was establishing the look of the SSR paperwork system. I designed and standardized the visual language for the show's files, forms, dossiers, labels, stamps, folders, and all in-world documentation used throughout the season, so the paper trail felt like a real agency with a real system behind it.",
      "I also handled ongoing research to support character and story canon, and built detailed investigation files and background dossiers that could hold up under scrutiny. A big part of that was photo manipulation and rapid-turnaround graphics — creating and altering images to serve multiple story needs (crime scene photos, autopsy photos, war portraits, mug shots), often when actors weren't available for proper photo sessions.",
      "In addition to background and investigative materials, I recreated hero paper props tied directly to MCU lore, including a version of the \"Project Rebirth\" file associated with Captain America — the kind of piece fans will pause to read, so it had to feel authentic and specific.",
      "On the specialty prop side, I worked closely with the prop master to arrange, modify, maintain, and source items for set, including tracking down true period pieces and identifying modern objects we could repurpose into believable 1940s props. One notable build challenge was the \"Nitramene\" orb: it began as a single detailed hero piece with a glowing core, but later the script called for a milk truck carrying hundreds of them. To keep the look consistent and stay within budget, we manufactured the multiples in-house using 70mm acrylic spheres filled with polyester fiber and small LED candle lights to sell the glow on camera.",
    ],
  },
  {
    slug: "office-christmas-party",
    title: "Office Christmas Party",
    subtitle: "60+ in-house 3D printed props · $55K saved",
    director: "Will Speck & Josh Gordon",
    studio: "Universal",
    year: "2016",
    role: "Assistant Property Master",
    poster: "/images/office-christmas-party.jpg",
    hero: "/images/ocp-bts.png",
    images: [
      "https://images.squarespace-cdn.com/content/v1/65431750d7376610b5f5026e/690be361-531f-4a0c-b2c1-e4a722d58ed8/Screenshot+2026-02-24+at+9.02.33%E2%80%AFPM.png",
      "https://images.squarespace-cdn.com/content/v1/65431750d7376610b5f5026e/d9b2fdcf-658a-44fd-9624-83bb11bc48c4/Screenshot+2026-02-24+at+9.02.27%E2%80%AFPM.png",
      "https://images.squarespace-cdn.com/content/v1/65431750d7376610b5f5026e/72866bbd-1f59-4fc4-b503-48d624a64500/Screenshot+2026-02-24+at+9.03.05%E2%80%AFPM.png",
    ],
    body: [
      "On Office Christmas Party (filmed in 2015), the script took the classic \"employees abusing the office copier\" gag and updated it for the modern era — except this time the office toy was a 3D printer, and the \"copies\" were… body parts. The problem was that in 2015, 3D scanning and printing wasn't the streamlined, affordable process it is now. Outsourcing the volume we needed would've been painfully expensive.",
      "I pushed for an in-house solution and got the go-ahead from the property master. I taught myself the basics of 3D scanning fast, then coordinated loaner equipment to make it happen: MatterHackers provided a turntable 3D scanner, and Fusion3D supplied a large-format professional printer in exchange for being featured on screen. To generate enough variety in the prints, I modified soft silicone adult novelty items by reshaping them with low-carbon steel wire, then scanned and printed the altered versions.",
      "At the time, each piece took roughly 13 hours from start to finish — most of that was print time — so the pipeline had to be tight and constantly moving. As the script evolved, we also needed the props for an explosive copy-room gag where prints get launched at the cast, including a hit-to-the-face moment with Jennifer Aniston. To keep everyone safe (and protect the set), I learned mold-making and produced foam duplicates for the stunt versions, which let us turn out an additional 40 props that could be thrown and blasted without risk.",
      "In about two weeks, I produced 60+ props in-house and saved the production over $55,000 — while still delivering the look, quantity, and on-camera functionality the scenes required.",
    ],
  },
  {
    slug: "popstar",
    title: "Popstar: Never Stop Never Stopping",
    subtitle: "Designing an iconic award-show trophy",
    director: "Akiva Schaffer & Jorma Taccone",
    studio: "Universal · Judd Apatow / The Lonely Island",
    year: "2016",
    role: "Assistant Property Master",
    poster: "/images/popstar.jpg",
    hero: "https://images.squarespace-cdn.com/content/v1/65431750d7376610b5f5026e/a2f47502-bae3-451e-9c01-e657c1e9fc39/MV5BMTczNzUzMTE2NF5BMl5BanBnXkFtZTgwNDQwMjk5ODE%40._V1_.jpg",
    images: [
      "https://images.squarespace-cdn.com/content/v1/65431750d7376610b5f5026e/a2f47502-bae3-451e-9c01-e657c1e9fc39/MV5BMTczNzUzMTE2NF5BMl5BanBnXkFtZTgwNDQwMjk5ODE%40._V1_.jpg",
      "https://images.squarespace-cdn.com/content/v1/65431750d7376610b5f5026e/21a010ab-5708-465a-827f-0ca4f8ca84fe/x1080.jpeg",
      "https://images.squarespace-cdn.com/content/v1/65431750d7376610b5f5026e/1d9e42dc-3354-41f5-b7bb-f2a405605a62/Screenshot+2026-02-24+at+9.05.45%E2%80%AFPM.png",
      "https://images.squarespace-cdn.com/content/v1/65431750d7376610b5f5026e/80fa11a2-4807-4b70-b0c9-c33501caa4bc/Screenshot+2026-02-24+at+9.05.54%E2%80%AFPM.png",
    ],
    body: [
      "On Popstar, the script called for an original, instantly recognizable award-show statue — basically our own \"Grammy\" — that would be featured prominently and repeatedly abused for laughs throughout the film. We weren't given much in the way of direction, so the prop master and I started from scratch: brainstorming, doing quick sketches, and narrowing down the design until we landed on a final concept that felt iconic on camera.",
      "Once the design was chosen, we were on a tight clock. I pulled together a clean rendering on the fly based on the final sketch, then worked directly with the artists at SAT to turn it into a buildable, film-ready piece fast. The goal was something that looked legit in close-up, read immediately from across the room, and could survive the punishment the script demanded — while still looking like a real awards-show trophy.",
      "In addition to the hero award, I was also responsible for researching and sourcing the DJ equipment and the correct instruments for the band, making sure everything was accurate to the music world we were spoofing and held up under scrutiny on camera.",
    ],
  },
];

export const CREDIBILITY = [
  { label: "Years Experience", value: "15+" },
  { label: "Union", value: "IATSE Local 44" },
  { label: "Property Trailer", value: "48' + Full Kit" },
  { label: "Fabrication", value: "Adobe / 3D Scanning & Printing" },
  { label: "Safety", value: "EFP Firearms + Safety Pass" },
  { label: "Travel", value: "Available Worldwide" },
];

export const STUDIOS = [
  "Paramount",
  "Universal",
  "Warner Bros",
  "HBO Max",
  "Netflix",
  "Disney+",
  "Apple TV+",
  "Amazon",
  "Hulu",
  "Marvel",
];

export const DIRECTORS = [
  "Judd Apatow",
  "Harold Ramis",
  "Jay Roach",
  "Oliver Stone",
  "Ivan Reitman",
  "Paul Feig",
  "Larry Charles",
  "Doug Liman",
];

export const WHAT_I_BRING = [
  {
    title: "Prepared for the Pivot",
    body: "Years spent under a veteran Property Master in Judd Apatow\u2019s comedy world, where things move fast and ideas can change in the moment. A training ground for staying ahead of the needs of the set \u2014 having options ready, supporting what the directors and actors bring to a scene, and keeping flexible.",
  },
  {
    title: "Department Leadership",
    body: "A strong property department starts with the right crew — built with care, not just availability. Department staff is chosen not only for skill and experience, but for the creativity, professionalism, attitude, and passion brought to the job. From prep through wrap, the goal is to keep the department efficient, adaptable, and in step with the needs of production, the designer, the director, and the cast.",
  },
  {
    title: "Fabrication + Graphics",
    body: "In-house fabrication and graphics support for custom builds, paper props, signage, labels, packaging, IDs, and replicated objects. With oversized printers, a 3D printer, 3D scanner, ID printer, and Adobe Suite inside the trailer, pieces can be designed, aged, distressed, and finished quickly. Detail matters — even when the audience may never consciously notice it. Keeping this work in-house gives production more flexibility, faster solutions, and lower costs.",
  },
  {
    title: "Archive-Level Detail",
    body: "Historical document recreation, cataloging, preservation, research, and careful handling of high-value or delicate assets.",
  },
  {
    title: "Trailer + Kit",
    body: "48' trailer with comprehensive kit available as part of my Property Master package — fewer rentals, more efficiency.",
  },
  {
    title: "On Set Safety",
    body: "Current EFP Firearms License and Safety Pass current for calm execution and crew protection mindset on every set.",
  },
];

export const FEATURED_PROJECTS = [
  {
    title: "Passenger",
    studio: "Paramount",
    role: "Property Master (LA Unit)",
    type: "Feature",
    year: "2026",
    poster: "/images/passenger.jpg".replace("/images/passenger.jpg", "/images/passenger.jpg"),
    trailer: "https://www.youtube.com/watch?v=eNIn8kW1kyE",
  },
  {
    title: "The Actor Awards",
    studio: "Netflix",
    role: "Property Master",
    type: "Commercial",
    year: "2026",
    poster: "/images/actor-awards.jpg",
    trailer: "https://www.youtube.com/watch?v=l5SnKmXR44E",
  },
  {
    title: "The Mother, the Menacer, and Me",
    studio: "Independent",
    role: "Property Master",
    type: "Feature",
    year: "2025",
    poster: "/images/mother-menacer.jpg",
    trailer: "https://www.youtube.com/watch?v=wPB81wkbaAU",
  },
  {
    title: "Rockbottom",
    studio: "Independent",
    role: "Property Master",
    type: "Feature",
    year: "2024",
    poster: "/images/rockbottom.jpg",
    trailer: "https://www.youtube.com/watch?v=US_MhdBLVcg",
  },
  {
    title: "It's a Wonderful Binge",
    studio: "Hulu",
    role: "Property Master",
    type: "Feature",
    year: "2022",
    poster: "/images/wonderful-binge.jpg",
    trailer: "https://www.youtube.com/watch?v=0zkcqqBKAJU",
  },
];

export const PROJECTS = {
  "Property Master": [
    { title: "Passenger", studio: "Paramount", director: "Johannes Roberts", year: "2026", note: "LA Unit Property Master" },
    { title: "The Actor Awards", studio: "Netflix", director: "Andrew Melby", year: "2026", note: "Property Master" },
    { title: "Whitney Springs", studio: "Paramount", director: "Trey Parker", year: "2026", note: "2nd Unit Property Master" },
    { title: "Mother, Menacer and Me", studio: "Independent", director: "Jon Salmon", year: "2025", note: "Property Master" },
    { title: "The Parenting", studio: "HBO Max", director: "Craig Johnson", year: "2025", note: "LA Unit Property Master" },
    { title: "Rockbottom", studio: "Independent", director: "Todd Tucker", year: "2024", note: "Property Master" },
    { title: "Lizzo Interstitials", studio: "HBO Max", director: "Sam Wrench", year: "2022", note: "LA Unit Property Master" },
    { title: "Get Rich Quick", studio: "Independent", director: "Steven Bernstein", year: "2022", note: "Property Master" },
    { title: "It's a Wonderful Binge / The Binge 2", studio: "Hulu", director: "Jordan VanDina", year: "2022", note: "Property Master" },
  ],
  "Assistant Property Master": [
    { title: "Hollywood Stargirl", studio: "Disney+", director: "Julia Hart", year: "2022", note: "Assistant Property Master" },
    { title: "The Shrink Next Door", studio: "Apple TV+", director: "Michael Showalter", year: "2021", note: "Assistant Property Master" },
    { title: "City of Lies", studio: "Miramax", director: "Brad Furman", year: "2018", note: "Assistant Property Master" },
    { title: "American Made", studio: "Universal", director: "Doug Liman", year: "2017", note: "Assistant Property Master" },
    { title: "Ghost in the Shell", studio: "Paramount", director: "Rupert Sanders", year: "2017", note: "Assistant Property Master" },
    { title: "All the Way", studio: "HBO", director: "Jay Roach", year: "2016", note: "Assistant Property Master" },
    { title: "Office Christmas Party", studio: "Universal", director: "Will Speck & Josh Gordon", year: "2016", note: "Assistant Property Master" },
    { title: "Popstar: Never Stop Never Stopping", studio: "Universal", director: "Akiva Schaffer & Jorma Taccone", year: "2016", note: "Assistant Property Master" },
  ],
  "Additional Property Experience": [
    { title: "A Star Is Born", studio: "Warner Bros", director: "Bradley Cooper", year: "2018", note: "Property Assistant" },
    { title: "Agent Carter", studio: "Marvel / ABC", year: "2016", note: "Property Production Assistant" },
    { title: "Savages", studio: "Universal", director: "Oliver Stone", year: "2012", note: "Property Production Assistant" },
    { title: "Bridesmaids", studio: "Universal", director: "Paul Feig", year: "2011", note: "Property Researcher" },
    { title: "No Strings Attached", studio: "Paramount", director: "Ivan Reitman", year: "2011", note: "Property Researcher" },
    { title: "Dinner for Schmucks", studio: "Paramount", director: "Jay Roach", year: "2010", note: "Property Researcher" },
    { title: "Get Him to the Greek", studio: "Universal", director: "Nicholas Stoller", year: "2010", note: "Property Researcher" },
    { title: "Funny People", studio: "Universal", director: "Judd Apatow", year: "2009", note: "Property Researcher" },
    { title: "Brüno", studio: "Universal", director: "Larry Charles", year: "2009", note: "Property Researcher" },
    { title: "Year One", studio: "Sony", director: "Harold Ramis", year: "2009", note: "Property Production Assistant" },
  ],
  "Archival Experience": [
    { title: "The Walt Disney Archives — Founding Contract", studio: "Disney", year: "", note: "Recreated & replicated historical document" },
    { title: "The Walt Disney Archives — Steamboat Willie Production Script", studio: "Disney", year: "", note: "Recreated & replicated historical document" },
    { title: "The Walt Disney Archives — Historical Merchandise Catalog", studio: "Disney", year: "", note: "Inventoried & cataloged historical merchandise" },
  ],
};

export const CASE_STUDIES = [
  {
    slug: "comedy-prop-support",
    title: "Comedy Prop Support",
    sub: "Improv-ready, continuity-honest, joke-aware.",
    img: "props2",
    body:
      "I trained for years under a veteran Property Master inside Judd Apatow's comedy world — a school of last-minute rewrites, actor invention, and props that have to keep up. Comedy requires a department that can move quickly without slowing production down. Whether the joke depends on a hero prop, a background visual gag, a piece of paperwork, or a fresh idea on the floor, I approach comedy with preparation, options, and calm execution.",
  },
  {
    slug: "historical-recreation",
    title: "Historical Recreation + Research",
    sub: "Period accuracy from source to set.",
    img: "typewriter1",
    body:
      "My early work as a property researcher gave me a strong foundation in historical accuracy, visual reference, and object authenticity. That experience later translated into archival work for The Walt Disney Company Archives, where I recreated historical documents including the Walt Disney Company founding contract and the Steamboat Willie production script. I bring that same research-based approach to production work — period paper props, real-world recreations, and pieces that need to feel specific, lived-in, and camera-ready.",
  },
  {
    slug: "department-management",
    title: "Department Management",
    sub: "From prep to wrap, calmly.",
    img: "bts",
    body:
      "As a Property Master, I manage the full lifecycle of the department: breakdown, budgeting, sourcing, fabrication, prep, set support, continuity, storage, transportation, and wrap. My years as an Assistant Property Master trained me to coordinate people, information, and materials under pressure. I focus on clear communication, realistic budgeting, organized tracking, and making sure the department supports the production rather than becoming a point of friction.",
  },
  {
    slug: "fabrication-graphics",
    title: "Fabrication + Graphics",
    sub: "In-house solutions before external delays.",
    img: "workshop2",
    body:
      "I bring in-house fabrication and graphics capabilities that allow the props department to respond quickly to production needs. From custom paper props and labels to distressed packaging, replica products, 3D-printed components, signage, and specialty builds — I can often solve problems internally before they become expensive external rentals or vendor delays.",
  },
  {
    slug: "archive-asset-care",
    title: "Archive-Level Asset Care",
    sub: "Tracked, protected, production-ready.",
    img: "shelves2",
    body:
      "I approach hero props and production assets with an archive-minded level of care. I track usage, condition, movement, and storage so items remain accessible, protected, and production-ready. That mindset is especially valuable when dealing with high-value hero props, delicate period pieces, specialty builds, or studio-owned assets that may need to be preserved after wrap.",
  },
  {
    slug: "trailer-kit-advantage",
    title: "Trailer + Kit Advantage",
    sub: "A 48' department infrastructure on day one.",
    img: "trailer",
    body:
      "My 48' trailer and comprehensive kit can be made available as part of my Property Master package, giving production a ready-to-work department infrastructure from day one. The trailer supports organization, storage, prep, transport, and quick on-set response, while reducing the need for additional rentals and helping the department stay efficient through prep, shoot, and wrap.",
  },
];

export const SERVICES = [
  {
    group: "Department Head",
    items: [
      "Script breakdown and prop analysis",
      "Prop budgeting and bid support",
      "Research and visual reference",
      "Sourcing and rentals",
      "Vendor coordination",
      "Buyer and assistant coordination",
      "On-set prop support",
      "Hero prop management",
      "Continuity tracking",
      "Cast / director prop adjustments",
      "Production meetings and art department coordination",
      "Wrap, asset return, and inventory closeout",
    ],
  },
  {
    group: "Fabrication + Graphics",
    items: [
      "Custom paper props",
      "Period documents",
      "Printed graphics",
      "Labels and packaging",
      "Signage",
      "Product replication",
      "3D printing",
      "Aging and distressing",
      "Research-based recreations",
      "Specialty prop builds",
      "Photoshop / Adobe Creative Suite",
    ],
  },
  {
    group: "Planning",
    items: [
      "Crew coordination",
      "Daily priority tracking",
      "Vendor communication",
      "Budget-conscious decision-making",
      "Prep and wrap planning",
      "Comms with producers, UPMs, designers, art directors, accounting, set",
      "Problem solving under shifting production needs",
    ],
  },
  {
    group: "Archive / Asset Management",
    items: [
      "Cataloging and inventory systems",
      "Condition notes",
      "Object tracking",
      "Prop preservation",
      "Historical research",
      "Chain-of-custody awareness",
      "Studio archive support",
      "Long-term asset storage planning",
    ],
  },
  {
    group: "Trailer + Kit",
    items: [
      "48' trailer",
      "Comprehensive property kit",
      "Storage and prep systems",
      "Tools and fabrication support",
      "Travel-ready department infrastructure",
    ],
  },
  {
    group: "Safety",
    items: [
      "Current EFP Firearms License",
      "Current Safety Pass",
      "Crew safety awareness",
      "Safe handling and storage practices",
      "Production-ready compliance mindset",
    ],
  },
];

export const TRAILER_FEATURES = [
  { title: "Organized Storage", body: "Shelving, labeled bins, and category-based zones for fast access during prep and shoot." },
  { title: "Prep + Wrap Support", body: "Workspace built for breakdown, fabrication, paper props, and clean, accountable wrap-out." },
  { title: "On-Set Flexibility", body: "Tools, supplies, and specialty stock close to set means quick response to last-minute needs." },
  { title: "Reduced Rental Needs", body: "Comprehensive kit reduces external rentals and the time it takes to chase last-minute orders." },
  { title: "Travel-Ready", body: "Built to roll. Available worldwide — past credits include LA, Atlanta, New York, New Orleans, and Chicago. Production-ready infrastructure where you need it." },
  { title: "Department Efficiency", body: "Stable base of operations through prep, shoot, and wrap — fewer surprises, fewer slowdowns." },
];

export const RESUME = {
  summaryParas: [
    "With over 15 years of experience in the film and television industry, I've built my career on a foundation of precision, creativity, and technical expertise. I started out as a production assistant and researcher for the prop department, gradually working my way up to Assistant Property Master and eventually Property Master. Along the way, I had the privilege of being mentored by a 35-year industry veteran, which helped shape my approach to sourcing, fabricating, and preserving props across a wide range of productions.",
    "I thrive in fast-paced, deadline-driven environments and take pride in my meticulous attention to detail. My strengths include managing and tracking complex inventories, maintaining on-set continuity, and protecting valuable assets under tight production timelines. My time as an Assistant Property Master gave me hands-on experience with prop prep, set support, and troubleshooting — skills I continue to rely on daily while collaborating with multiple departments.",
    "Whether I'm recreating historical objects for a biopic or designing props for a futuristic world, I always aim to merge authenticity with innovation. I stay current with emerging tools and techniques, including 3D printing and digital design, and I bring a deep understanding of archival practices, preservation, and contextual research to every project. These experiences have made me a flexible, reliable, and detail-focused member of any creative team.",
  ],
  experience: [
    {
      heading: "Property Master",
      items: [
        { title: "The Actors Awards", studio: "Netflix", director: "Andrew Melby", type: "Commercial", year: "2026", role: "Property Master", link: "https://www.youtube.com/watch?v=l5SnKmXR44E" },
        { title: "Passenger", studio: "Paramount", director: "Johannes Roberts", type: "Feature", year: "2026", role: "Los Angeles Unit Property Master", imdb: "https://www.imdb.com/title/tt33763941/" },
        { title: "Whitney Springs", studio: "Paramount", director: "Trey Parker", type: "Feature", year: "2026", role: "2nd Unit Property Master", imdb: "https://www.imdb.com/title/tt17042980/" },
        { title: "Mother, Menacer and Me", studio: "Indp.", director: "Jon Salmon", type: "Feature", year: "2025", role: "Property Master", imdb: "https://www.imdb.com/title/tt32551244/" },
        { title: "Ancestry.com", studio: "Ancestry", director: "Blaine Hoaan", type: "Commercial", year: "2025", role: "Property Master", link: "https://www.youtube.com/watch?v=RsfvrDUrdLc" },
        { title: "The Parenting", studio: "HBO Max", director: "Craig Johnson", type: "Feature", year: "2025", role: "Los Angeles Unit Property Master", imdb: "https://www.imdb.com/title/tt14041896/" },
        { title: "Rockbottom", studio: "Amazon", director: "Todd Tucker", type: "Feature", year: "2024", role: "Property Master", imdb: "https://www.imdb.com/title/tt26694194/" },
        { title: "Lizzo Interstitials", studio: "HBO Max", director: "Sam Wrench", type: "Commercial · Music Video", year: "2022", role: "Property Master", link: "https://www.youtube.com/watch?v=6-35WQDkPSA" },
        { title: "Get Rich Quick", studio: "Indp.", director: "Steven Bernstein", type: "Feature", year: "2022", role: "Property Master", imdb: "https://www.imdb.com/title/tt18260078/" },
        { title: "It's a Wonderful Binge", studio: "HULU", director: "Jordan VanDina", type: "Feature", year: "2022", role: "Property Master", imdb: "https://www.imdb.com/title/tt16532314/" },
      ],
    },
    {
      heading: "Assistant Property Master",
      items: [
        { title: "Hollywood Stargirl", studio: "Disney+", director: "Julia Hart", type: "Feature", year: "2021", role: "Asst. Property Master", imdb: "https://www.imdb.com/title/tt14109994/" },
        { title: "The Valet", studio: "Hulu", director: "Richard Wong", type: "Feature", year: "2021", role: "Los Angeles Unit Asst. Property Master", imdb: "https://www.imdb.com/title/tt4081630/" },
        { title: "The Shrink Next Door", studio: "Apple TV+", director: "Michael Showalter", type: "Limited Series", year: "2021", role: "Asst. Property Master", imdb: "https://www.imdb.com/title/tt11947248/" },
        { title: "City of Lies", studio: "Miramax", director: "Brad Furman", type: "Feature", year: "2018", role: "Asst. Property Master", imdb: "https://www.imdb.com/title/tt2677722/" },
        { title: "American Made", studio: "Universal", director: "Doug Liman", type: "Feature", year: "2017", role: "NOLA Unit Asst. Property Master", imdb: "https://www.imdb.com/title/tt3532216/" },
        { title: "Ghost in the Shell", studio: "Paramount", director: "Rupert Sanders", type: "Feature", year: "2017", role: "Los Angeles Unit Asst. Property Master", imdb: "https://www.imdb.com/title/tt1219827/" },
        { title: "All the Way", studio: "HBO", director: "Jay Roach", type: "TV Movie", year: "2016", role: "Asst. Property Master", imdb: "https://www.imdb.com/title/tt3791216/" },
        { title: "Office Christmas Party", studio: "Universal", director: "Josh Gordon & Will Speck", type: "Feature", year: "2016", role: "Asst. Property Master", imdb: "https://www.imdb.com/title/tt1711525/" },
        { title: "Popstar: Never Stop Never Stopping", studio: "Universal", director: "Akiva Schaffer & Jorma Taccone", type: "Feature", year: "2016", role: "Asst. Property Master", imdb: "https://www.imdb.com/title/tt3960412/" },
      ],
    },
    {
      heading: "Additional Property Experience",
      items: [
        { title: "A Star Is Born", studio: "Warner Bros", director: "Bradley Cooper", type: "Feature", year: "2018", role: "Property Assistant", imdb: "https://www.imdb.com/title/tt1517451/" },
        { title: "Agent Carter", studio: "Marvel / ABC", type: "TV Series", year: "2016", role: "Property Production Assistant", imdb: "https://www.imdb.com/title/tt3475734/" },
        { title: "Savages", studio: "Universal", director: "Oliver Stone", type: "Feature", year: "2012", role: "Property Production Assistant", imdb: "https://www.imdb.com/title/tt1615065/" },
        { title: "Bridesmaids", studio: "Universal", director: "Paul Feig", type: "Feature", year: "2011", role: "Property Researcher", imdb: "https://www.imdb.com/title/tt1478338/" },
        { title: "No Strings Attached", studio: "Paramount", director: "Ivan Reitman", type: "Feature", year: "2011", role: "Property Researcher", imdb: "https://www.imdb.com/title/tt1411238/" },
        { title: "Dinner for Schmucks", studio: "Dreamworks", director: "Jay Roach", type: "Feature", year: "2010", role: "Property Researcher", imdb: "https://www.imdb.com/title/tt0427152/" },
        { title: "Step Up 3D", studio: "Disney", director: "Jon M. Chu", type: "Feature", year: "2010", role: "Los Angeles Unit Property Production Assistant", imdb: "https://www.imdb.com/title/tt1193631/" },
        { title: "Get Him to the Greek", studio: "Universal", director: "Nicholas Stoller", type: "Feature", year: "2010", role: "Property Researcher", imdb: "https://www.imdb.com/title/tt1226229/" },
        { title: "Raaaaaaaandy!", studio: "Universal", director: "Jason Woliner", type: "DVD Special Feature", year: "2008", role: "Property Master", imdb: "https://www.imdb.com/title/tt2360802/" },
        { title: "Funny People", studio: "Universal", director: "Judd Apatow", type: "Feature", year: "2009", role: "Property Researcher", imdb: "https://www.imdb.com/title/tt1201167/" },
        { title: "Brüno", studio: "Universal", director: "Larry Charles", type: "Feature", year: "2009", role: "Property Production Assistant", imdb: "https://www.imdb.com/title/tt0889583/" },
        { title: "Year One", studio: "Sony", director: "Harold Ramis", type: "Feature", year: "2009", role: "Property Production Assistant", imdb: "https://www.imdb.com/title/tt1045778/" },
      ],
    },
  ],
  skills: [
    {
      name: "Prop Management and Archiving",
      body: "Developed and maintained organized systems for cataloging, storing, and tracking props, ensuring proper preservation, quick access, and smooth on-set operations. Logged each prop's condition, usage, and location to minimize delays and optimize resource utilization within budget constraints.",
    },
    {
      name: "Design, Fabrication, and Historical Accuracy",
      body: "Designed, constructed, and replicated props across a wide range of styles — from futuristic to vintage — using tools such as 3D printing and Photoshop. Conducted in-depth research into historical periods and materials to ensure authenticity and enhance world-building. Balanced creative vision with practical execution while managing fabrication budgets and material sourcing.",
    },
    {
      name: "Continuity & Attention to Detail",
      body: "Oversaw on-set continuity by tracking the placement, condition, and usage of props throughout production. Created and maintained detailed continuity logs to ensure consistency across scenes and prevent visual discrepancies. Paid close attention to fine, camera-visible details, ensuring props supported both narrative and visual integrity.",
    },
    {
      name: "Preservation and Asset Care",
      body: "Ensured physical integrity of all props through proper handling, maintenance, and archival storage, including delicate or high-value items. Applied preservation techniques that reduced the risk of damage, minimized costly replacements, and maintained long-term asset value for future use or reference.",
    },
  ],
  archival: {
    org: "The Walt Disney Archives",
    body: "Recreated and replicated historical documents as part of a specialized preservation project, including:",
    items: [
      "The Walt Disney Company Founding Contract",
      "Steamboat Willie Production Script",
      "Inventoried and cataloged historical merchandise",
    ],
  },
  affiliations: [
    {
      org: "International Alliance of Theatrical Stage Employees",
      role: "Local 44 (IATSE)",
    },
    {
      org: "The Property Masters Guild",
      role: "Former Secretary (PMG)",
    },
    {
      org: "Academy of Television Arts & Sciences",
      role: "Member",
    },
  ],
};
